import "./abstract-base-BwSTXh2a.js";
import { e as S } from "./query-Dk6NwgU8.js";
import { e as b } from "./base-CwU3eNq-.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let f;
function d(e) {
  return (n, t) => b(n, t, { get() {
    var a;
    return ((a = this.renderRoot) != null ? a : f != null ? f : f = document.createDocumentFragment()).querySelectorAll(e);
  } });
}
const m = ({
  finisher: e,
  descriptor: n
}) => (
  // eslint-disable-next-line consistent-return
  (t, a) => {
    var r;
    if (a !== void 0) {
      const o = t.constructor;
      n !== void 0 && Object.defineProperty(t, a, n(a)), e == null || e(o, a);
    } else {
      const o = (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (r = t.originalKey) != null ? r : t.key
      ), l = n !== void 0 ? {
        kind: "method",
        placement: "prototype",
        key: o,
        descriptor: n(t.key)
      } : { ...t, key: o };
      return e && (l.finisher = function(c) {
        e(c, o);
      }), l;
    }
  }
);
function i(e, n, t = {}, a = !1) {
  var l;
  const r = `slot${n ? `[name=${n}]` : ":not([name])"}`, o = (l = e.renderRoot) == null ? void 0 : l.querySelector(r);
  return o ? a ? o.assignedNodes(t).filter((c) => c.nodeType !== Node.COMMENT_NODE) : o.assignedElements(t) : [];
}
function y(e) {
  return typeof e == "string" ? { version: e } : e.alternateSlot !== void 0 && e.alternateSlot !== null ? { alternateSlot: e.alternateSlot, version: e.version } : { alternateAttribute: e.alternateAttribute, version: e.version };
}
function A(e, n = !1) {
  const { slot: t, selector: a, deprecated: r, flatten: o } = e != null ? e : {};
  let l;
  return r && (l = y(r)), m({
    descriptor: (c) => ({
      get() {
        let u = i(this, t, { flatten: o });
        return u.length === 0 && r && l && l.alternateSlot && (u = i(this, l.alternateSlot, { flatten: o })), a ? u == null ? void 0 : u.filter((s) => {
          var g;
          return n ? ((g = s == null ? void 0 : s.nodeName) == null ? void 0 : g.toLowerCase()) === this.getScopedTagName(a) : s.matches(a);
        }) : u;
      },
      set(u) {
        if (r) {
          const s = t != null ? t : "";
          this.alternateSlots.set(s, l);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function E(e) {
  return function(n, t) {
    return S(e)(n, t);
  };
}
function q(e, n) {
  return m({
    descriptor: (t) => ({
      get() {
        var r;
        return (r = this.querySelector(e)) != null ? r : null;
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function k(e) {
  return function(n, t) {
    return d(e)(n, t);
  };
}
function C(e, n = !1) {
  const { slot: t, selector: a, deprecated: r, flatten: o } = e != null ? e : {};
  let l;
  return r && (l = y(r)), m({
    descriptor: (c) => ({
      get() {
        let u = i(this, t, { flatten: o }, !0);
        return u.length === 0 && r && l && l.alternateSlot && (u = i(this, l.alternateSlot, { flatten: o }, !0)), u;
      },
      set(u) {
        if (r) {
          const s = t != null ? t : "";
          this.alternateSlots.set(s, l);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
export {
  A as a,
  E as b,
  k as c,
  C as d,
  q,
  d as r
};
